import styles from './index.module.css'
import React from 'react'
import Button from 'components/ui/button'
export const LoadMore = () => (
  <div className={styles.container}>
    <Button
      appearance="primary"
      caption="+ load more results"
      fullWidth
      textCenter
    />
  </div>
)
